<template>
  <div class="content_wrap">
    <div class="	">
      <div class="register_main clearfix">
        <div class="register_main_top">
          <span class="second_font">机构开发者注册</span>
          <span class="register_user"><i class="content_font">已有账号?</i>
            <a
              class="content_link"
              href="#/login"
            >立即登录</a>
          </span>
        </div>
        <!--<div class="step_status step2"></div>-->
        <div class="registe_item_box">
          <!--<div class="message_item clearfix">
							<span class="input_item_left content_font">机构名称：</span>
							<span class="input_item_right" v-text="OrganizationName">百望股份有限公司</span>
						</div>

						<div class="message_item clearfix">
							<span class="input_item_left content_font">企业邮箱：</span>
							<span class="input_item_right" v-text="email">lishuo@baiwang.com</span>
						</div>

						<div class="message_item clearfix">
							<span class="input_item_left content_font">联系电话：</span>
							<span class="input_item_right" v-text="phone">13838384381</span>
						</div>-->
          <div class="input_item clearfix">
            <label class="input_item_left content_font"><i>*</i>机构名称：</label>
            <div class="input_item_right">
              <input
                class="input_common"
                v-model='OrganizationName'
                type="text"
                placeholder="请输入您的机构全称"
              />
            </div>
          </div>

          <div class="input_item  clearfix">
            <label class="input_item_left content_font"><i>*</i>联系电话：</label>
            <div class="input_item_right">
              <input
                class="input_common"
                v-model="phone"
                type="text"
                placeholder="请输入您的联系电话，用于接收重要通知"
              />
            </div>
          </div>
          <div class="input_item clearfix">
            <label class="input_item_left content_font"><i>*</i>企业邮箱：</label>
            <div class="input_item_right">
              <input
                class="input_common"
                v-model="email"
                type="text"
                placeholder="请输入您的企业邮箱，用于接收通知"
              />
            </div>
          </div>
          <div class="input_item clearfix">
            <label class="input_item_left content_font"><i>*</i>验证码：</label>
            <div class="input_item_right">
              <div id="slider"></div>
            </div>
          </div>

          <div class="input_item clearfix">
            <label class="input_item_left content_font"><i>*</i>短信验证码：</label>
            <div class="input_item_right">
              <input
                class="input_common"
                v-model="smsCode"
                type="text"
                placeholder="请输入您的短信验证码"
              >
              <a
                href="javascript:;"
                class="yam_btn"
                @click="smsVerification"
                v-text="seconds"
              >获取短信验证码</a>
            </div>
          </div>

          <!--<p class="step_note">请确认填写正确的信息，最终审核结果会通过短信和邮件通知您，请务必填写准确</p>-->
        </div>
        <div class="checkBox">
          <p>
            <img
              :src="imgCheckFlag?checkImg:noCheckImg "
              alt=""
              @click="imgCheckFlag=!imgCheckFlag"
              class="checkImg"
            >
            同意<a
              href="/#/privacyServiceAgreement"
              target="_blank"
            >《银税通平台隐私政策》</a>
          </p>
        </div>
        <div class="register_btn_box registerStyle">
          <!--						<a href="#/register/firstStep" class="bluebd_btn mr10">&nbsp;取&nbsp;&nbsp;消&nbsp;</a>
-->
          <a
            class="login_btn second_font "
            @click="sumbit"
          >下一步</a>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import SliderVerification from '../../assets/js/slider'
import noCheckImg from '@/assets/images/check.png'
import checkImg from '@/assets/images/checked.png'

export default {
  name: 'firstStep',
  data() {
    return {
      OrganizationName: '', //机构名称
      email: '', //企业邮箱
      phone: '', //联系电话
      smsCode: '',
      isShow: true, //短信验证码60秒显示
      seconds: "获取短信验证码",
      isGetCode: false, //是否已经滑块验证通过
      noCheckImg: noCheckImg,
      checkImg: checkImg,
      imgCheckFlag: false // 是否通过了隐私协议
    }
  },
  mounted() {
    //生成滑块
    new SliderVerification('#slider', {
      width: '330',
      height: '40',
      verifInfo: '/ystOpenPlatformBff/api/verifInfo',
      checkVerif: '/ystOpenPlatformBff/api/checkVerif',
    });
  },
  methods: {
    sumbit() {
      let params = {
        "companyName": this.OrganizationName,
        "phone": this.phone,
        "email": this.email,
        //					'smsCode': this.smsCode
      }
      if (this.check.calibration(params)) {

        if (sessionStorage.getItem('token') || this.isGetCode) {
          params.smsCode = this.smsCode;
          if (this.check.calibration(params)) {
            if (!this.imgCheckFlag) {
              return this.$Message.error({
                content: "请先勾选同意相关协议",
                duration: 2
              })
            }
            this.http.post('/ystOpenPlatformBff/register', params, res => {
              if (res.success) {
                this.$router.push('/register/thirdStep')
              } else {
                this.$Message.error({
                  content: res.message,
                  duration: 2
                })
              }
            })
          }
        } else {
          this.$Message.error({
            content: '滑块验证码证书失效或者未验证,请验证滑块验证码！',
            duration: 2
          })
        }
      }
    },
    //短信验证
    smsVerification() {
      const that = this;
      if (this.isShow) {
        let params = {
          telephoneNum: this.phone,
          cert: sessionStorage.getItem('token')
        }
        if (this.check.calibration(params)) {
          this.http.post('/ystOpenPlatformBff/sendSmsCode', params, res => {
            if (res.success) {
              this.$Message.info({
                content: '获取手机验证码成功，请输入手机上的验证码完成验证！',
                duration: 2
              })
              sessionStorage.setItem('token', '')
              this.isShow = false;
              let time = 60;
              this.isGetCode = true
              let timer = setInterval(function () {
                if (time > 0) {
                  that.seconds = time + "秒后重新验证"
                  time--;
                } else {
                  clearInterval(timer)
                  that.isShow = true;
                  that.seconds = "获取短信验证码";
                  this.isGetCode = false;
                  $('#slider').html('')
                  new SliderVerification('#slider', {
                    width: '330',
                    height: '40',
                    verifInfo: '/ystOpenPlatformBff/api/verifInfo',
                    checkVerif: '/ystOpenPlatformBff/api/checkVerif',
                  });
                }
              }, 1000)
            } else {
              this.isGetCode = false
              this.$Message.error({
                content: '滑块验证码证书失效或者未验证,请验证滑块验证码！',
                duration: 2
              })
            }
          })
        }
      }
    }
  }
}
</script>

<style lang="scss">
.step2 {
  background: url(../../assets/images/regist_step2.jpg) no-repeat;
  background-size: 100%;
}
.checkImg {
  margin-bottom: -4px;
  padding-right: 4px;
}
.checkBox {
  padding-left: 80px;
  padding-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/_register/SecondStep.vue